<template>
  <div class="navBox">
     <div>
      <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
        <el-breadcrumb-item to="/homeNav">首页</el-breadcrumb-item>
        <el-breadcrumb-item>因子分析</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="ellipsis">
      <div class="navList fl">
        <ul>
          <li
            :class="[
              routerType >= 1 ? 'optMove' : 'noMove',
              routerType == 1 ? 'radiu' : '',
            ]"
          >
            单标的因子分析
          </li>
          <li
            :class="[
              routerType >= 2 ? 'optMove' : 'noMove',
              routerType == 2 ? 'radiu' : '',
            ]"
          >
            单天、单因子、多标的分析
          </li>
          <li
            :class="[
              routerType >= 3 ? 'optMove' : 'noMove',
              routerType == 3 ? 'radiu' : '',
            ]"
          >
            单因子分析
          </li>
          <li
            :class="[
              routerType >= 4 ? 'optMove' : 'noMove',
              routerType == 4 ? 'radiu' : '',
            ]">
            单天、多因子、多标的分析
          </li>
        </ul>
      </div>
      <div class="fr">
        <el-button
          size="small"
          @click="stepBtn(false)"
          v-if="routerType <= 5 && routerType != 1"
          >上一步</el-button>
        <el-button
          type="primary"
          size="small"
          @click="getStep(true)"
          v-if="routerType < 5"
          >下一步</el-button>
        <!-- <el-button
          type="primary"
          size="small"
          @click="finish"
          v-if="routerType == 4"
          >完成</el-button> -->
      </div>
    </div>
    <div style="margin-top: 20px; height: 100%">
      <router-view></router-view>
    </div>
     <topic :initData="examContentData" :dialog="dialogTopic" @getSucceed="getSucceed"
     ref="topic"></topic>
  </div>
</template>
<script>
import topic from "@/components/subjectDialog/topic.vue";
export default {
  components:{topic},
  data() {
    return {
      examContentData: [],
      dialogTopic: false,
       numData: 0, // 题目数量
      routerType: 1,
      listData: [],
      stepMap: {
        // 对接国家虚仿平台
        1: "singlefactor",
        2: "singleanalysis",
        3: "aloneanalysis",
        4: "multiplefactor"
      }
    };
  },
  mounted() {
    if (this.$route.query.url == "/factorAnalysis/singlefactor") {
      this.routerType = 1;
    } else if (this.$route.query.url == "/factorAnalysis/singleanalysis") {
      this.routerType = 2;
    } else if (this.$route.query.url == "/factorAnalysis/aloneanalysis") {
      this.routerType = 3;
    } else if (this.$route.query.url == "/factorAnalysis/multiplefactor") {
      this.routerType = 4;
    } else {
      this.routerType = 1;
    }
  },
  methods: {
    setILabData(topicDataArr) {
      let score = 100;
      let rightItem = 0;
      let totalItem = topicDataArr.length;
      // 判断分数
      topicDataArr && topicDataArr.forEach((item, index) => {
        if (item.is_correct === "True") rightItem += 1;
      });

      if(totalItem > 0) {
        score = Math.ceil((rightItem / totalItem) * 100);
      }
      
      let params = {
        name: this.stepMap[this.routerType],
        score,
        evaluation: "",
        scoringModel: "答题得分"
      };

      console.log("this.stepMap[this.routerType]",this.stepMap[this.routerType]);
      this.$ILab.EndStep(this.stepMap[this.routerType],params);

    },
     // 下一步答题
    getStep(type){
      this.examContentData = [];
        this.numData = 0;
        this.dialogTopic = false;
        this.$refs.topic.reset();
   if (this.$route.query.url  == "/factorAnalysis/singlefactor") {
       let param = ["singlefactor"];
       this.examContent(param);
    } else if (this.$route.query.url == "/factorAnalysis/singleanalysis") {
       let param = ["factor-1"];
       this.examContent(param);
    } else if (this.$route.query.url == "/factorAnalysis/aloneanalysis") {
       let param = ["factor-2"];
       this.examContent(param);
    } else if (this.$route.query.url == "/factorAnalysis/multiplefactor") {
       let param = ["factor-3"];
       this.examContent(param);
    }
      
    },
    getSucceed(arr){
      this.setILabData(arr);
      if (this.$route.query.url == "/factorAnalysis/multiplefactor") {
        this.$router.push({
          path: "/popup",
          query: {
            url: '/experimentNav',
          },
        });
      }
      this.stepBtn(true);
    },
    examContent(param) {
      const than = this;
      this.$api.hubei.examContent(param).then((res) => {
        this.examContentData = [];
        const datas = [];
        res.topicTOS.forEach((element, ids) => {
          datas.push({
            ...element,
            type_hove: "",
          });
        });
        this.examContentData = datas;
        this.numData = res.topicTOS.length;
        this.dialogTopic = true;
        this.$nextTick(()=>{
          than.$refs.topic.init()
        })
      });
    },
    // 步骤
    stepBtn(type) {
      if (type) {
        this.routerType++;
      } else {
        this.routerType--;
      }
      if (this.routerType == 1) {
        this.$router.push({
          path: "/factorAnalysis/singlefactor",
          query: {
            url: "/factorAnalysis/singlefactor",
          },
        });
      } else if (this.routerType == 2) {
        this.$router.push({
          path: "/factorAnalysis/singleanalysis",
          query: {
            url: "/factorAnalysis/singleanalysis",
          },
        });
      } else if (this.routerType == 3) {
        this.$router.push({
          path: "/factorAnalysis/aloneanalysis",
          query: {
            url: "/factorAnalysis/aloneanalysis",
          },
        });
      } else if (this.routerType == 4) {
        this.$router.push({
          path: "/factorAnalysis/multiplefactor",
          query: {
            url: "/factorAnalysis/multiplefactor",
          },
        });
      }
    },
    // 完成
    finish() {
      this.routerType = 1;
    },
  },
  created() {},
};
</script>
<style lang="less" scoped>
.navBox {
  background: #f7f9ff;
  width: 1400px;
  margin: 0 auto;
   .breadcrumb{
    height: 40px;
    line-height: 40px;
    font-size: 16px;
  }
  .navList {
    background: #dddddd;
    border-radius: 15px;
    color: #999999;
    ul {
      clear: both;
      overflow: hidden;
      width: 1000px;
      background: #dddddd;
      border-radius: 15px;
      color: #999999;
      li {
        width: 250px;
        display: inline-block;
        height: 30px;
        line-height: 30px;
        text-indent: 10px;
        font-size: 16px;
      }
      .optMove {
        background: #baccde;
        color: #3f98f1;
        // border-radius: 1px 12px 12px 1px;
      }
    }
  }
}
.optMove::before {
  content: "";
  width: 30px;
  height: 30px;
  background: #0079ff;
  float: left;
  border-radius: 50%;
}

.noMove::before {
  content: "";
  width: 30px;
  height: 30px;
  background: #999999;
  float: left;
  border-radius: 50%;
}
.radiu {
  border-radius: 1px 12px 12px 1px;
}
.box-list {
  padding: 24px 0 0 24px;
  .research_list {
    display: inline-block;
    margin: 0 15px;
    cursor: pointer;
    position: relative;
    color: #fff;
    margin-bottom: 20px;
    // background: #003D56;
    // box-shadow: inset 0px 0px 32px 0px rgba(63,152,241,1); // 内阴影
    // border-radius: 8px;
    img {
      height: 388px;
    }
  }
  .research_tit {
    position: absolute;
    bottom: 0;
    width: 416px;
    height: 89px;
    text-align: center;
    line-height: 66px;
    .list_name {
      font-size: 18px;
      margin-bottom: 20px;
    }
    .list_desc {
      width: 130px;
      margin: 0 auto;
      display: -webkit-box;
      overflow: hidden;
      white-space: normal !important;
      text-overflow: ellipsis;
      word-wrap: break-word;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }
  }
}
.boxBg {
  width: 330px;
  height: 395px;
  // background: url("../../assets/image/research1.png");
}
</style>